import { extend } from 'vee-validate';
import StudentService from '@/services/StudentService';

extend('student_id_unique', {
  validate: (id) => {
    return StudentService.validateId(id)
      .then((response) => {
        return {
          valid: response.data.isValid,
        };
      })
      .catch(() => {
        return {
          valid: false,
        };
      });
  },
});
